<template>
    <div>
        <PedidoContentPdf ref="pedidoContentPdf" :image="image" :pedv="pedv" :index="index" @handleHtmlContent="printHtmlContent" />
    </div>
</template>

<script>
import { apiORDS, apiORDSapp, apiORDSmidia, apiDownloadPDF } from '../shared/api-functions'
import PedidoContentPdf from './pedido-content-pdf.vue'

export default {
    components:{
        PedidoContentPdf
    },
    props: {
        index: {
            type: Number,
            require: true
        },
    },
    data() {
        return {
            pedv: null,
            uuid: null,
            image: null,
        }
    },
    watch: {
        index() {
            // console.log(this.index)
        }
    },
    computed:{
        orderOrBudgetId(){
            if(this.pedv){
                if(!this.pedv.npedido){
                    return 'Orçamento: ' + this.pedv.ncotacao
                } else{
                    return 'Pedido: ' + this.pedv.npedido
                }
            }
        },
    },
    methods: {
      async beforeDownload ({ html2pdf, options, pdfContent }) {
          options.margin = [0.5, 0]
          options.image = {type: 'jpeg', quality: 0.98}
          options.html2Canvas = {scale: 1}

          await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
              const totalPages = pdf.internal.getNumberOfPages()
              for (let i = 1; i <= totalPages; i++) {
                  pdf.setPage(i);
                  pdf.setFontSize(10);
                  pdf.setTextColor(150);
                  pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                  // html2pdf().set({
                  //     pagebreak: { mode: 'avoid-all', before:`${id}` }
                  // });
              }
          }).save()
      },
      async loadData() {
          if (this.uuid) {
              const data = await apiORDSapp(this, 'linkpdf/imprimirpedido/' + this.uuid, 'get', null)
              if (data) {
                  this.pedv = data.items[0]
                  if (this.pedv.filial.length && this.pedv.filial[0].logotipo) {
                      this.image = 'data:image/jpeg;base64,' + this.pedv.filial[0].logotipo
                  }
                  this.print()
              }
          } else {
              const data = await apiORDS(this.$store.getters.urlOrds + 'sales/pedv/' + this.index, null)
              if (data) {
                  if (!this.image && data.items[0].filial.length) {
                      let self = this
                      await apiORDSmidia(this.$store.getters.urlApp + 'logo/download/' + data.items[0].filial[0].codempresa + '/' + data.items[0].filial[0].codfil).then(
                          response => {
                              if (response && response.size > 0) {
                                  let reader = new window.FileReader();
                                  reader.readAsDataURL(response);
                                  reader.onload = function() {
                                      self.image = reader.result;
                                  }
                              }
                          }
                      )
                  }
                  this.pedv = data.items[0]
                  if (this.pedv.filial.length){
                    this.pedv.filial[0].parametros = JSON.parse(this.pedv.filial[0].parametros)
                  }

              }
          }

          this.prepareGrade();
          // console.log('this.pedv.filial[0].logotipo')
          // console.log(this.pedv.filial[0])
      },

      printHtmlContent(htmlContent) {
          let filename = this.orderOrBudgetId
          filename = filename.replace(': ', '') + '.pdf'
          const sendData = { header: htmlContent[0], body: htmlContent[1] }
          apiDownloadPDF(this, '/htmlpdf', sendData, 'post', false, filename)
          this.$emit('close');
      },

      prepareGrade(){
        let cp_pedvit = []
        this.pedv.pedvit.map((item) => {
          let it = {...item}
          it.isgrade = false
          cp_pedvit.push(it)
          if (item.pedvgrade.length > 0) {
            let it_grade = {...item}
            it_grade.totbru = 0;
            it_grade.totliq = 0;
            it_grade.qt = 0;
            it_grade.qtuni = 0;
            it_grade.isgrade = true
            cp_pedvit.push(it_grade)
          }

        })
        this.pedv.pedvit = cp_pedvit;

      },

      print() {
          this.$refs.pedidoContentPdf.getHtmlContent();
      }
    },
    created () {
        if (this.$route.name == 'imprimir-pedido') {
            if (this.$route.query && this.$route.query.uuid) {
                this.uuid = this.$route.query.uuid
            } else {
                this.$router.push('/login')
                return
            }
        }

        this.loadData();

    },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/pedido-impressao.vue